export const checkIfUserEmailExists = {
	getMessage(field) {
		return "Ein Benutzer mit dieser eMail-Adresse existiert bereits.";
	},
	validate(value, args) {
		if(value && value !== args[0]) {
			return Vue.http.get('utils/checkIfUserEmailExists/' + value).then(function(response) {
				// console.log(response.body);
				return response.body;
			});
		} else {
			return true;
		}
	},
};



// WEBPACK FOOTER //
// ./src/validator/checkIfUserEmailExists.js